var _defs, _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGooglePlay(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 916.9 271.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: url(#linear-gradient2);\n      }\n\n      .st1 {\n        fill: #010101;\n      }\n\n      .st2, .st3 {\n        fill: #fff;\n      }\n\n      .st4 {\n        fill: url(#linear-gradient1);\n      }\n\n      .st5 {\n        fill: #a6a5a5;\n      }\n\n      .st6 {\n        fill: red;\n      }\n\n      .st7 {\n        fill: url(#linear-gradient3);\n      }\n\n      .st8 {\n        fill: url(#linear-gradient);\n      }\n\n      .st3 {\n        isolation: isolate;\n        opacity: .1;\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 139.2,
    y1: 217.2,
    x2: 139.2,
    y2: 52,
    gradientTransform: "translate(0 271.9) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#267caf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#4a92b4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#79bcba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#88cebc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient1",
    x1: 224.7,
    y1: 153.7,
    x2: 204.5,
    y2: 108.1,
    gradientTransform: "translate(0 271.9) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f48879"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#f5907a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#fbb777"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fdc874"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient2",
    x1: 194.7,
    y1: 119,
    x2: 104,
    y2: 45.7,
    gradientTransform: "translate(0 271.9) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eb413d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#d94452"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#af487a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#954b92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#894a9c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient3",
    x1: 110.4,
    y1: 212.8,
    x2: 197.2,
    y2: 146.5,
    gradientTransform: "translate(0 271.9) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#54c0ac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dde79a"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st6",
    x: 266,
    y: 52.9,
    width: 598,
    height: 182.9
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M910.8,239.6c0,14.4-11.7,26-26,26H32.1c-14.4,0-26.1-11.6-26.1-26V32.1c0-14.4,11.7-26,26.1-26h852.6c14.4,0,26,11.7,26,26h0v207.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M884.8,271.7H32.1C14.4,271.7,0,257.3,0,239.6V32.1C0,14.4,14.4,0,32.1,0h852.6c17.7,0,32.1,14.4,32.1,32.1v207.5c0,17.7-14.4,32.1-32.1,32.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M910.8,239.6c0,14.4-11.7,26-26,26H32.1c-14.4,0-26.1-11.6-26.1-26V32.1c0-14.4,11.7-26,26.1-26h852.6c14.4,0,26,11.7,26,26h0v207.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M884.8,0h-456.7l178.9,271.7h277.8c17.7,0,32.1-14.4,32.1-32.1V32.1C916.9,14.4,902.5,0,884.8,0h0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M461.5,113.4c-15.9,0-28.6,11.9-28.6,28.6s12.6,28.6,28.6,28.6,28.6-11.9,28.6-28.6-12.6-28.6-28.6-28.6ZM461.5,158.6c-8.6,0-15.9-7.3-15.9-17.3s7.3-17.3,15.9-17.3,15.9,6.6,15.9,17.3-7.3,17.3-15.9,17.3ZM399.7,113.4c-15.9,0-28.6,11.9-28.6,28.6s12.6,28.6,28.6,28.6,28.6-11.9,28.6-28.6-12.6-28.6-28.6-28.6ZM399.7,158.6c-8.6,0-15.9-7.3-15.9-17.3s7.3-17.3,15.9-17.3,15.9,6.6,15.9,17.3-7.3,17.3-15.9,17.3ZM326,122.1v12h28.6c-.7,6.6-3.3,11.9-6.6,15.3-4,4-10.6,8.6-21.9,8.6-17.9,0-31.2-13.9-31.2-31.9s14-31.9,31.2-31.9,16.6,4,21.9,8.6l8.6-8.6c-7.3-6.6-16.6-11.9-29.9-11.9-23.9,0-44.5,19.9-44.5,43.8s20.6,43.8,44.5,43.8,22.6-4,30.5-12.6c8-8,10.6-19.3,10.6-27.9s0-5.3-.7-7.3h-41.2ZM627.5,131.4c-2.7-6.6-9.3-17.9-23.9-17.9s-26.6,11.3-26.6,28.6,12,28.6,27.9,28.6,20.6-8,23.2-12.6l-9.3-6.6c-3.3,4.6-7.3,8-14,8s-10.6-2.7-14-8.6l37.8-15.9-1.3-3.3h0ZM589,140.7c0-10.6,8.6-16.6,14.6-16.6s9.3,2.7,10.6,6l-25.2,10.6h0ZM557.8,167.9h12.6v-83h-12.6v83ZM537.8,119.4c-3.3-3.3-8.6-6.6-15.3-6.6-14,0-27.2,12.6-27.2,28.6s12.6,27.9,27.2,27.9,12-3.3,14.6-6.6h.7v4c0,10.6-6,16.6-15.3,16.6s-12.6-5.3-14-10l-10.6,4.6c3.3,7.3,11.3,16.6,25.2,16.6s26.6-8.6,26.6-29.2v-50.5h-12v4.7h0ZM523.2,158.6c-8.6,0-15.9-7.3-15.9-17.3s7.3-17.3,15.9-17.3,15.3,7.3,15.3,17.3-6.6,17.3-15.3,17.3ZM685.3,84.9h-29.9v83h12.6v-31.2h17.3c14,0,27.2-10,27.2-25.9s-13.3-25.9-27.2-25.9h0ZM685.9,124.7h-17.9v-28.6h17.9c9.3,0,14.6,8,14.6,13.9-.7,7.3-6,14.6-14.6,14.6h0ZM762.3,112.8c-9.3,0-18.6,4-21.9,12.6l11.3,4.6c2.7-4.7,6.6-6,11.3-6,6.6,0,12.6,4,13.3,10.6v.7c-2-1.3-7.3-3.3-12.6-3.3-12,0-23.9,6.6-23.9,18.6s10,18.6,20.6,18.6,12.6-4,15.9-8h.7v6.6h12v-31.9c-1.3-14.6-12.6-23.2-26.6-23.2h0ZM761,158.6c-4,0-10-2-10-7.3s7.3-8.6,13.3-8.6,8,1.3,11.3,2.7c-1.3,8-8,13.3-14.6,13.3ZM830.7,114.8l-14,35.9h-.7l-14.6-35.9h-13.3l21.9,50.5-12.6,27.9h12.6l33.9-78.4h-13.3ZM719.1,167.9h12.6v-83h-12.6v83Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M98.7,55.1c-2,2-2.7,5.3-2.7,9.3v146.8c0,4,1.3,7.3,3.3,9.3l.7.7,82.4-82.3v-1.3L98.7,55.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M208.9,166.7l-27.2-27.2v-2l27.2-27.2.7.7,32.5,18.6c9.3,5.3,9.3,13.9,0,19.3l-33.2,17.9h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M209.6,166l-27.9-27.9-83,83c3.3,3.3,8,3.3,13.9.7l97-55.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M209.6,110.3l-97-55.1c-6-3.3-10.6-2.7-13.9.7l83,82.3,27.9-27.9h0Z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlay);
export default __webpack_public_path__ + "static/media/GooglePlay.8d2b7a4808337e4fe6310fd9e353a0f9.svg";
export { ForwardRef as ReactComponent };